import React from 'react';
import styles from './ErrorPage.module.css';
import { CustomButton } from '../../components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const ErrorPage = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <h1>{ t('error.error') }</h1>
                <p className={styles.msg}>{ t('error.error_msg') }</p>

                <CustomButton className={styles.btn} onClick={() => { navigate('/') }}>{ t('error.go_home') }</CustomButton>
            </div>
        </div>
    );
};

export default ErrorPage;